import api from '@/api/worldLocation'

const state = {

}

const actions = {
  getCommonCityList (context, params) {
    return api.getCommonCityList(params)
  },
  getCityRegionList (context, { cityId, params }) {
    return api.getCityRegionList(cityId, params)
  },
  getCityRegionCbdList (context, { cityId, regionId, params }) {
    return api.getCityRegionCbdList(cityId, regionId, params)
  },
  getCountryList () {
    return api.getCountryList()
  },
  getProvinceList (context, params) {
    return api.getProvinceList(params)
  },
  getCityList (context, params) {
    return api.getCityList(params)
  },
  getWorldLocationList (context, params) {
    return api.getWorldLocationList(params)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
